import React from "react";
import "./Council.css";

const members = [
  {
    role: "President",
    name: "ROSHAN SINGH",
    desc: "Director, RSPL Group",
    icon: "fa-user-tie",
  },
  {
    role: "Vice President",
    name: "RAJAT GOEL",
    desc: "Social Activist",
    icon: "fa-user-shield",
  },
  {
    role: "Vice President",
    name: "VARUN GOENKA",
    desc: "CEO, Dream Solutions",
    icon: "fa-user-shield",
  },
  {
    role: "Secretary General",
    name: "PANKAJ",
    desc: "CEO, DIIA Event Solutions",
    icon: "fa-users",
  },
  {
    role: "Treasurer",
    name: "GAYATRI PUNETHA",
    desc: "Environmentalist",
    icon: "fa-leaf",
  },
  {
    role: "Executive Member",
    name: "GAJENDRA SINGH JADON",
    desc: "Chairman, EES MP Chapter",
    icon: "fa-users",
  },
  {
    role: "Executive Member",
    name: "PUSHPENDRA SINGH",
    desc: "Agriculturist",
    icon: "fa-users",
  },
  {
    role: "Executive Member",
    name: "PRACHI RANA",
    desc: "Educationist",
    icon: "fa-users",
  },
];

const Council = () => {
  return (
    <section id="council" className="council">
      <h2>GOVERNING COUNCIL</h2>

      <div className="council-grid">
        {members.map((m, i) => (
          <div className="council-card" key={i}>
            
            {/* ICON */}
            <div className="icon">
              <i className={`fa-solid ${m.icon}`}></i>
            </div>

            <div className="card-content">
              <span className="role">{m.role}</span>
              <h3>{m.name}</h3>
              <p>{m.desc}</p>
            </div>

          </div>
        ))}
      </div>
    </section>
  );
};

export default Council;